import { deriveTier, hasAccessToContacts as hasAccessToContactsFn } from 'services/tierGating';

export const onBoardingSwitcher = ({ user, network, networkSlug, pathMatch }) => {
  if (!user) return '/';

  const { networkSlug: onboardingNetworkSlug, employerSlug } = pathMatch?.params || {};

  if (onboardingNetworkSlug && employerSlug && !user.onboardingCompleted) {
    return `/networks/${onboardingNetworkSlug}/company/${employerSlug}/welcome`;
  }

  if (!network) return '/';

  const onboardingHome = `/networks/${networkSlug}/welcome/onboarding`;

  // Use tier-based logic instead of legacy connect.hasAccess
  const tierResult = deriveTier(network);
  const isCustomer = hasAccessToContactsFn(tierResult);
  const hasGoals = network.userGoalsAnswered;
  const { onboardingCompleted } = user;

  // Non-customers: only see step 1 (profile), then go to network root
  if (!isCustomer) {
    if (onboardingCompleted) {
      return `/networks/${networkSlug}`;
    }
    return onboardingHome;
  }

  // Customers: full onboarding flow
  if (!onboardingCompleted) {
    return onboardingHome;
  }

  // Onboarding completed but missing network kind - go to network-kind step
  if (!network.kind) {
    return `/networks/${networkSlug}/welcome/onboarding/network-kind`;
  }

  // Onboarding completed but missing goals - go to goals step
  if (!hasGoals) {
    return `/networks/${networkSlug}/welcome/onboarding/goals`;
  }

  // Fully completed - go to home
  return `/networks/${networkSlug}/home`;
};

export const mapRoleToPermissions = ({ role, networkSlug, user, network, pathMatch }) => {
  switch (role) {
    case 'authenticated':
      return {
        routes: ['all', 'user', 'job_board'],
        home: '/',
      };
    case 'unauthenticated':
      return {
        routes: ['all', 'public'],
        home: '/login',
      };
    case 'unconfirmed':
      return {
        routes: ['all', 'user'],
        home: '/verify-email',
      };
    case 'onboarding':
    case 'ally': {
      let home = `/networks/${networkSlug}/welcome/onboarding`;
      if (user?.isOnlyAlly) {
        const mode = !user?.oauthProviders?.length && !user.hasPassword ? 'email' : 'social';

        home = user?.onboardingCompleted
          ? `/onboarding/${user.allyingCollections[0].slug}/ally-signup`
          : `/onboarding/${user.allyingCollections[0].slug}/ally-signup/profile/${mode}`;
      } else if (user?.isOnlyCompanyAdmin) {
        const slug = networkSlug || user.managingOrganizations[0].collections[0].slug;

        home = `/claim-your-profile/${slug}`;
      } else {
        home = onBoardingSwitcher({ user, network, networkSlug, pathMatch });
      }

      return {
        routes: ['all', 'onboarding'],
        home,
      };
    }
    default:
      return [['all'], '/'];
  }
};

export const setRole = ({ authenticated, onboardingCompleted, isOnlyAlly, confirmed }) => {
  if (!authenticated) return 'unauthenticated';
  if (!confirmed) return 'unconfirmed';
  if (isOnlyAlly && !onboardingCompleted) return 'ally';
  if (!onboardingCompleted) return 'onboarding';
  return 'authenticated';
};
